export const LAST_USED_VISTORS_PASS_PRINTER =
  'visitors.printPass.lastUsedPrinter';
export const MAX_LENGTH_FOR_FLOOR_TEXT = 30;
